(function() {
    'use strict';

    angular
        .module('soopkitchenApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('password', {
            parent: 'account',
            url: '/password',
            data: {
                authorities: ['ROLE_INSTRUMENT_COORDINATOR', 'ROLE_INSTRUMENT_TEAM_MEMBER', 'ROLE_USER', 'ROLE_POWER_USER', 'ROLE_PLAN_COORDINATOR', 'ROLE_ADMIN'],
                pageTitle: 'Password'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/password/password.html',
                    controller: 'PasswordController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();
